import * as THREE from 'three';

/** Neutron star sphere radius in scene units */
export const STAR_RADIUS = 1.0;

/** Axis line length beyond the star surface in scene units */
export const AXIS_LENGTH = 3.0;

/** Maximum jet particle travel distance from surface in scene units */
export const MAX_JET_DISTANCE = 15.0;

/** Initial camera position */
export const CAMERA_INITIAL_POSITION = new THREE.Vector3(0, 12, 18);

/** Minimum orbit distance from origin in scene units */
export const CAMERA_MIN_DISTANCE = 2.0;

/** Maximum orbit distance from origin in scene units */
export const CAMERA_MAX_DISTANCE = 50.0;

/** Maximum delta time per frame in seconds (prevents visual jumps from lag spikes) */
export const DELTA_TIME_CLAMP = 0.1;

/** Scene background color (near-black, luminance < 10%) */
export const BACKGROUND_COLOR = 0x0a0a0f;

/** Default semi-major axis of the orbit in scene units */
export const ORBIT_SEMI_MAJOR_AXIS = 9.2;

/** Default eccentricity of the orbit [0, 0.99] */
export const ORBIT_ECCENTRICITY_DEFAULT = 0.3;

/** Default orbital speed in revolutions per second [0.01, 2.0] */
export const ORBIT_SPEED_DEFAULT = 0.06;

/** Number of line segments used to render the orbit path */
export const ORBIT_LINE_SEGMENTS = 256;

/** Opacity of the orbit path line [0.2, 0.5] */
export const ORBIT_LINE_OPACITY = 0.3;

/** Maximum iterations for Kepler's equation solver (Newton-Raphson) */
export const KEPLER_MAX_ITERATIONS = 50;

/** Convergence tolerance for Kepler's equation solver */
export const KEPLER_TOLERANCE = 1e-8;

/** Default number of segments per field line curve */
export const FIELD_LINE_SEGMENTS_DEFAULT = 64;

/** Maximum total segment budget across all field lines */
export const FIELD_LINE_SEGMENT_BUDGET = 5000;

/** Minimum segments per curve floor */
export const FIELD_LINE_SEGMENTS_MIN = 16;

/** Default field line color (light blue/cyan) */
export const FIELD_LINE_COLOR_DEFAULT = '#4fc3f7';

/** Default field line opacity */
export const FIELD_LINE_OPACITY_DEFAULT = 0.6;
